import { Mail, Phone, MapPin, Clock } from "lucide-react";
import Reveal from "./Reveal";

const CONTACT = [
  {
    icon: Mail,
    label: "Email Us",
    value: "info@bsglobalventures.com",
    href: "mailto:info@bsglobalventures.com",
  },
  {
    icon: Phone,
    label: "Call Us",
    value: "+91 90040 15183",
    href: "tel:+919004015183",
  },
  {
    icon: MapPin,
    label: "Based In",
    value: "India",
  },
  {
    icon: Clock,
    label: "Response Time",
    value: "Within 24–48 business hours",
  },
];

export default function ContactStrip() {
  return (
    <section className="section-shell !py-8 md:!py-10 border-t border-border bg-surface-alt/40">
      <div className="section-inner">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {CONTACT.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.label} delay={i * 80}>
                <div className="flex items-start gap-4 sm:flex-col sm:items-center sm:text-center">
                  <div className="w-10 h-10 rounded-full bg-accent/15 flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-accent" />
                  </div>
                  <div>
                    <p className="text-xs label-cap text-muted">{item.label}</p>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="mt-1 block text-sm font-medium text-primary hover:text-accent transition-colors"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="mt-1 text-sm font-medium text-primary">{item.value}</p>
                    )}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
